import React from "react";
import styled from "styled-components";
import { Radius, background, transparentize } from "@glossy";
import { Locale } from "@linkfluence/models/locale";
import UiKitButton from "@ui-kit/button";
import { tr } from "@radarly/i18n";

interface IProps {
  overflowTitleCard?: boolean;
  needReload: boolean;
  onClickReload: () => void;
  locale: Locale;
}

const Overlay = styled.div<{
  isVisible: boolean;
  overflowTitleCard: boolean;
}>`
  position: absolute;
  inset: ${(props) => (props.overflowTitleCard ? "-107px 0 0" : "0")};
  border-radius: ${Radius.MediumLarge};
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => transparentize(0.25, background(props))};
  pointer-events: ${(props) => !props.isVisible && "none"};
`;

const ReloadFromAIGenerationIssueOverlay = ({
  needReload = false,
  onClickReload,
  overflowTitleCard,
  locale,
}: IProps) => (
  <Overlay overflowTitleCard={overflowTitleCard} isVisible={needReload}>
    <UiKitButton size="l" onClick={() => onClickReload()} variant="primary">
      {tr(locale, "INSIGHT-PAGES::EMPTY-GENERATE-ANALYSIS")}
    </UiKitButton>
  </Overlay>
);

export default ReloadFromAIGenerationIssueOverlay;
